import { Loading, MUIIcon } from "../../widgets";
import React, { useEffect } from "react"
import { useGetSiteQuery, useLazyGetMembersByUserIdQuery } from "../../services/auth";
import { useNavigate, useSearchParams } from "react-router-dom"

import { IMember } from "../../services/auth/models/Member.model";
import { ISite } from "../../services/auth/models";
import { LayoutSplashScreen } from "../../../layout/core";
import { SiteCard } from "./components";
import { useAuth } from "../../../modules/auth";

export const SitesGridView = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { user, setSite, logout } = useAuth()
    const [getUserSites, { data, isLoading, isFetching, isError, isSuccess }] = useLazyGetMembersByUserIdQuery()

    useEffect(() => {
        if (!user?.userId)
            return;

        getUserSites(user?.userId)
        // eslint-disable-next-line
    }, [user])

    const onSelectSite = (site: ISite, item: IMember) => {
        setSite(site.portalId)
        const next = searchParams.get("next");

        return navigate(next || `/site(${site.portalId})/dashboard`, { replace: true })
    }

    if (isLoading || isFetching) {
        return <LayoutSplashScreen />
    }

    if (isError) {
        return <div>Something went wrong.</div>
    }

    if ((isSuccess && data) && data.length === 0) {
        return <>
            <div className="d-flex flex-column align-items-center text-center h-100">
                <div>
                    <div className="my-5"><i className="las la-thumbs-up fs-4x text-primary"></i></div>
                    <div className="mx-20 mb-10 fs-6 fw-semibold text-gray-700">
                        You will receive an e-mail notification, when your login registration is accepted.
                        <div className="my-1">You can logout for now.</div>
                    </div>
                </div>

                <button type="button" className="btn btn-sm btn-secondary py-2 d-flex gap-1" onClick={logout}>
                    <MUIIcon iconName="LogoutOutlined" />
                    <span>Logout</span>
                </button>
            </div>
        </>
    }

    return (<div className="container">
        <div className="d-flex align-items-center mt-10 mb-10 ">
            <div className="border w-50px h-50px bg-info rounded-circle d-flex align-items-center justify-content-center me-3">
                <MUIIcon iconName="WebOutlined" className="fs-2x text-white" />
            </div>
            <h1 className="fw-bolder">Site Collection</h1>
        </div>
        <div className="d-flex align-items-stretch flex-wrap ">
            {data?.map(item => <React.Fragment key={item.id}>
                <div className="d-flex align-items-stretch w-lg-25 w-md-50 w-sm-300px p-2">
                    <SiteCardInner
                        className="border w-100"
                        siteId={item.portalId}
                        onSelect={(portal) => onSelectSite(portal, item)} />
                </div>
            </React.Fragment>)}
        </div>
    </div>)
}

const SiteCardInner = ({ siteId, onSelect, className }: {
    siteId: string,
    onSelect?: (portal: ISite) => void
    className?: string
}) => {
    const { data: site, isLoading, isFetching, isSuccess } = useGetSiteQuery(siteId)

    if (isLoading || isFetching) {
        return <Loading status="Pending" />
    }

    if (!isSuccess) {
        return <div className="alert alert-danger">Failed to load data.</div>
    }

    return (
        <SiteCard onClick={onSelect} site={site} className={className} />
    )
}
